import {designsApi} from './index';
import {createSelector} from '@reduxjs/toolkit';
import {deserialize} from '~/data/deserializers/cart';
import {buildUrl, getCartToken} from '~/utils/url';

export const cartApi = designsApi.injectEndpoints({
  overrideExisting: false,
  endpoints: builder => ({
    getCart: builder.query({
      query: () => {
        const token = getCartToken();
        const searchParams = new URLSearchParams();
        searchParams.set('digest', `${Date.now()}`);
        if (token) {
          searchParams.set('token', token);
        }
        return {
          url: `checkout/cart?${searchParams.toString()}`
        };
      },
      transformResponse: res => deserialize(res)
    }),
    addDesignToCart: builder.mutation({
      query: ({designCompositeId}) => ({
        url: buildUrl('checkout/add_to_cart', {
          cid: designCompositeId
        })
      }),
      transformResponse: res => deserialize(res),
      async onQueryStarted(arg, {dispatch, queryFulfilled}) {
        try {
          const {data} = await queryFulfilled;
          dispatch(
            cartApi.util.updateQueryData('getCart', undefined, draft => {
              Object.assign(draft, data);
            })
          );
        } catch {
          /* no-op */
        }
      }
    })
  })
});

export const {
  useGetCartQuery,
  useAddDesignToCartMutation,
  endpoints: cartEndpoints
} = cartApi;

// Selectors
export const selectCartResult = cartEndpoints.getCart.select();

export const selectCartItems = createSelector([selectCartResult], cart =>
  Object.values(cart.data?.items ?? {})
);

export const selectCartItemsCount = state => selectCartItems(state).length;

export const selectCartSubTotal = state => selectCartResult(state).data?.total;

export const selectCartEmail = state => selectCartResult(state).data?.email;
